import { Controller } from "@hotwired/stimulus"

export default class extends Controller {
  static targets = ["fileInput", "image"]

  openFileDialog() {
    this.fileInputTarget.click()
  }

  connect() {
    this.fileInputTarget.addEventListener('change', this.handleFileSelect.bind(this))
  }

  handleFileSelect(event) {
    const file = event.target.files[0]
    if (file) {
      // Preview the image immediately
      const reader = new FileReader()
      reader.onload = (e) => {
        this.imageTarget.src = e.target.result
      }
      reader.readAsDataURL(file)

      // Optional: Auto-submit the form
      this.element.closest('form').requestSubmit()
    }
  }
} 